import { Tab as MuiTab } from "@mui/material";

import { Box } from "ui/box/box";
import { END_ICON_ATTRIBUTE } from "ui/tabs/tabs.constants";
import { type TabProps } from "ui/tabs/tabs.types";
import { useTab } from "ui/tabs/use-tab";

/**
 * MUI's `Tab` takes one icon. The end icon rides inside the label instead, after the text, so the
 * tab's own `gap` spaces it as Figma's `spacing` variables do on both sides.
 */
export const Tab = ({ label, startIcon, endIcon, ref, ...rest }: TabProps) => {
  const { iconOnlyProps } = useTab({ label, startIcon });

  return (
    <MuiTab
      ref={ref}
      label={
        endIcon ? (
          <>
            {label}
            <Box component="span" {...{ [END_ICON_ATTRIBUTE]: true }}>
              {endIcon}
            </Box>
          </>
        ) : (
          label
        )
      }
      icon={startIcon}
      iconPosition="start"
      {...iconOnlyProps}
      {...rest}
    />
  );
};
